import React, {Component} from 'react';
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import {appConfig} from '../../../config';
var dateFormat = require('dateformat');

class ChemistOrderView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itempage: 0,
      itemsperPage: 5,
    };
  }

  //For pagination
  itemsPageClick = ev => {
    const selecteditemPage = ev.selected;
    this.props.itempageSelected({
      item: this.props.orderToShow,
      page: selecteditemPage + 1,
    });
    this.setState({itempage: selecteditemPage});
  };

  resetitemPage = () => {
    //For resetting the itemdetail table to page 1 in pagination
    this.setState({
      ...this.state,
      itempage: 0,
    });
  };

  render() {
    const data =
      this.props.orderToShow && this.props.orderToShow.item
        ? this.props.orderToShow.item
        : null;

    //Destructuring
    const {show, close, chemistOrderDtls, chemistOrderDtlsCount} = this.props;
    const {itempage, itemsperPage} = this.state;
    const {itemsPageClick} = this;

    //For pagination
    const itemcount = chemistOrderDtlsCount;
    let p1 = itempage + 1;
    let itemPageCount = Math.ceil(itemcount / itemsperPage);

    return (
      <div>
        <div>
          <Modal
            show={show}
            onHide={close}
            animation={false}
            className="chemistmodeldiv"
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Chemist Order Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col xs={12} sm={12} md={8} lg={8}>
                  {/* <h6>
                    Order ID:{' '}
                    {data !== null && data.orderNo ? data.orderNo : null}|
                    <span className="cmn_Cap">
                      {data !== null && data.orderTrk
                        ? data.orderTrk
                        : null}{' '}
                      Order
                    </span>
                    <br />
                    Remarks:{' '}
                    <span className="cmn_Cap">
                      {data !== null && data.prcpNotes
                        ? data.prcpNotes
                        : 'No additional notes'}
                    </span>
                  </h6> */}
                  <h6 style={{lineHeight: 1.5}}>
                    Order ID :{' '}
                    <span className="cmn_Cap">
                      {data !== null && data.orderNo ? data.orderNo : null}
                    </span>
                    <br />
                    Order Type :{' '}
                    <span className="cmn_Cap">
                      {data !== null && data.orderTrk
                        ? data.orderTrk
                        : null}{' '}
                      Order
                    </span>
                    <br />
                    Remarks :{' '}
                    <span className="cmn_Cap">
                      {data !== null && data.prcpNotes
                        ? data.prcpNotes
                        : 'No additional notes'}
                    </span>
                  </h6>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <h6 style={{lineHeight: 1.5}}>
                    Order Status :{' '}
                    <span className="cmn_Cap">
                      {data !== null && data.status
                        ? data.status === 'shipmentReady'
                          ? 'Dispatched'
                          : data.status
                        : null}
                    </span>
                    <br />
                    Order Date :{' '}
                    <span className="cmn_Cap">
                      {data !== null &&
                        data.createdAt !== null &&
                        dateFormat(data.createdAt, 'dd-mmm-yyyy')}
                    </span>
                  </h6>
                </Col>
              </Row>
              <hr />

              <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p className="boldClass">Order From:</p>
                    {/* <p>
                      <span className="cmn_Cap">
                        {data !== null && data.orderFrom
                          ? data.orderFrom.name + " " + data.orderFrom.lName
                          : "---"}
                      </span>
                      <br />
                      <span className="cmn_Cap">
                        {data !== null && data.orderFromName
                          ? data.orderFromName
                          : "---"}
                      </span>
                      <br />
                      {data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.mobileNo
                        : "---"}
                      <br />
                      {data !== null && data.chmstDtls && data.chmstDtls.email
                        ? data.chmstDtls.email
                        : "---"}
                      <br />
                      {data !== null && data.chmstDtls && data.chmstDtls.website
                        ? data.chmstDtls.website
                        : "---"}
                      <br />
                      <span className="cmn_Cap">
                        {data !== null && data.addr},{" "}
                        {data !== null && data.pincode}
                      </span>
                    </p> */}

                    <p>
                      <span className="cmn_Cap"> Name : </span>{' '}
                      {data !== null && data.orderFrom
                        ? data.orderFrom.name + ' ' + data.orderFrom.lName
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Org Name : </span>{' '}
                      {data !== null && data.orderFromName
                        ? data.orderFromName
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Mobile : </span>{' '}
                      {data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.mobileNo
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Email : </span>{' '}
                      {data !== null && data.chmstDtls && data.chmstDtls.email
                        ? data.chmstDtls.email
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Website : </span>{' '}
                      {data !== null && data.chmstDtls && data.chmstDtls.website
                        ? data.chmstDtls.website
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Address : </span>{' '}
                      {data !== null && data.addr},{' '}
                      {data !== null && data.pincode}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={4} lg={4} />

                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p className="boldClass">Order To:</p>
                    {/* <p>
                      <span className="cmn_Cap">
                        {data !== null && data.orderTo
                          ? data.orderTo.name + ' ' + data.orderTo.lName
                          : '---'}
                      </span>
                      <br />
                      <span className="cmn_Cap">
                        {data !== null && data.orderToName
                          ? data.orderToName
                          : '---'}
                      </span>
                      <br />
                      {data !== null && data.orderTo !== null && data.orderTo
                        ? data.orderTo.mobileNo
                        : '---'}
                      <br />
                      {data !== null && data.orderTo !== null && data.orderTo
                        ? data.orderTo.email
                        : '---'}
                      <br />
                      <span>
                        {data !== null &&
                        data.dstbtrDtls &&
                        data.dstbtrDtls.city
                          ? data.dstbtrDtls.city
                          : '---'}
                      </span>
                      <br />
                      <span className="cmn_Cap">
                        {data !== null &&
                          data.dstbtrDtls &&
                          data.dstbtrDtls.addr1},{' '}
                        {data !== null &&
                          data.dstbtrDtls &&
                          data.dstbtrDtls.zip}
                      </span>
                    </p> */}

                    <p>
                      <span className="cmn_Cap"> Name : </span>{' '}
                      {data !== null && data.orderTo
                        ? data.orderTo.name + ' ' + data.orderTo.lName
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Org Name : </span>{' '}
                      {data !== null && data.orderToName
                        ? data.orderToName
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Mobile : </span>{' '}
                      {data !== null && data.orderTo !== null && data.orderTo
                        ? data.orderTo.mobileNo
                        : '---'}
                      <br />
                      <span className="cmn_Cap"> Email : </span>{' '}
                      {data !== null && data.orderTo !== null && data.orderTo
                        ? data.orderTo.email
                        : '---'}
                      <br />
                      {/* <span className="cmn_Cap"> Website : </span>{' '}
                      {data !== null && data.chmstDtls && data.chmstDtls.website
                        ? data.chmstDtls.website
                        : '---'}
                      <br /> */}
                      <span className="cmn_Cap"> Address : </span>{' '}
                      {data !== null &&
                        data.dstbtrDtls &&
                        data.dstbtrDtls.addr1},{' '}
                      {data !== null && data.dstbtrDtls && data.dstbtrDtls.zip}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h4>Item Details</h4>
                </Col>

                <Col xs={12} sm={12} md={3} lg={3} />
                <Col xs={12} sm={12} md={3} lg={3} />

                <Col xs={12} sm={12} md={3} lg={3}>
                  <div>
                    {/* <i className="cui-note icons cmnRecordIcon"></i> */}
                    <span className="cmnPageCount">
                      {chemistOrderDtlsCount !== undefined
                        ? chemistOrderDtlsCount
                        : 0}
                    </span>
                    <span className="cmnResutText">Items</span>
                  </div>
                </Col>
              </Row>
              <Table responsive bordered className="cmnMainTable">
                <thead>
                  <tr>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    {/* <th>Batch Number</th> */}
                    <th>Unit</th>
                    <th>Order Quantity</th>
                    <th> Available Quantity</th>
                    {/* <th>Tax Amount</th>
                    <th>Unit Cost</th>
                    <th>Unit Rate</th>
                    <th>Unit Price</th> */}
                    <th>Availability</th>
                    {/* <th>Created Date & Time </th> */}
                  </tr>
                </thead>
                {chemistOrderDtls !== undefined &&
                  chemistOrderDtlsCount !== 0 &&
                  chemistOrderDtls &&
                  chemistOrderDtls.map((item, i) =>
                    <tbody key={i}>
                      <tr>
                        <td>
                          {item !== null &&
                          item.itemCode &&
                          item.itemCode.drugCode
                            ? item.itemCode.drugCode
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null &&
                          item.itemCode &&
                          item.itemCode.drugName
                            ? item.itemCode.drugName
                            : null}
                        </td>
                        {/* <td>
                          {item !== null &&
                          item.itemCode &&
                          item.itemCode.batchNo
                            ? item.itemCode.batchNo
                            : null}
                        </td> */}
                        <td>
                          {item !== null &&
                            item.unitType !== null &&
                            item.unitType !== undefined &&
                            item.unitType.name}
                        </td>

                        <td>
                          {item !== null && item.qntty ? item.qntty : null}
                        </td>
                        <td>
                          {item !== null && item.avlblQntty ? item.avlblQntty : null}
                        </td>
                        {/* <td>
                          {item !== null &&
                          item.itemCode &&
                          item.itemCode.taxAmnt
                            ? item.itemCode.taxAmnt
                            : null}
                        </td>
                        <td>
                          {item !== null &&
                          item.itemCode &&
                          item.itemCode.unitCost
                            ? item.itemCode.unitCost
                            : null}
                        </td>
                        <td>
                          {item !== null && item.unitRate
                            ? item.unitRate
                            : null}
                        </td>
                        <td></td> */}
                        <td>
                          {item !== null && item.avlble == true ? 'Yes' : 'No'}
                        </td>
                        {/* <td>{item!==null&&item.createdAt&&dateFormat(item.createdAt,"dd-mmm-yyyy, h:MM TT")}</td> */}
                      </tr>
                    </tbody>
                  )}
              </Table>
              {itemPageCount > 1
                ? <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={itempage}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={itemPageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={itemsPageClick}
                      containerClassName={'pagination flex-wrap'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  </div>
                : null}
              {(chemistOrderDtls === undefined ||
                (chemistOrderDtls && chemistOrderDtlsCount === 0)) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">No Items Found</div>
                </div>}
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#f0f3f5'}} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default ChemistOrderView;
